module.exports = __webpack_public_path__ + "img/sicon_05.4718400d.png";